export default "__VITE_ASSET__CIfj3pUy__"